import React from 'react';
import { Link } from 'react-router-dom';
import { IssueThumbnail } from './CoverThumbnail.jsx';

function IssueCard({ issue }) {
  const {
    volume = '',
    issueNumber = '',
    season = '',
    year = '',
    articleCount = null,
    upcoming = false,
    coverImage = null,
  } = issue || {};
  const target = issue?.id ? `/issues/${issue.id}` : '/issues';
  const label = `${volume}${issueNumber ? `, Issue ${issueNumber}` : ''}`;

  return (
    <article className="group flex flex-col overflow-hidden rounded-xl border border-bg-border bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg">
      <Link to={target} className="block aspect-[16/10] w-full flex-shrink-0 overflow-hidden bg-navy">
        <IssueThumbnail
          src={coverImage}
          alt={`${label} cover`}
          volume={volume.replace(/^Vol\.\s*/, '')}
          issueNumber={issueNumber}
          className="transition-transform duration-300 group-hover:scale-105"
        />
      </Link>

      <div className="flex flex-1 flex-col gap-2 p-4">
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <h3 className="font-display text-navy font-semibold text-base">
            {label}
          </h3>
          {upcoming ? (
            <span className="text-xs font-sans font-semibold bg-amber-tint text-amber-tinttext px-2 py-0.5 rounded-full">
              Upcoming
            </span>
          ) : (
            <span className="text-xs font-sans font-semibold bg-green-100 text-green-800 px-2 py-0.5 rounded-full">
              Published
            </span>
          )}
        </div>

        <p className="font-sans text-slate text-sm">
          {season} {year}
        </p>

        {!upcoming && articleCount !== null && (
          <p className="font-sans text-xs text-gray-500">
            {articleCount} {articleCount === 1 ? 'article' : 'articles'}
          </p>
        )}

        {upcoming && (
          <p className="font-sans text-xs text-gray-500 italic">Articles forthcoming</p>
        )}

        <div className="mt-auto pt-3 border-t border-bg-border">
          <Link
            to={target}
            className={`inline-flex items-center gap-1 text-xs font-sans font-semibold transition-colors ${
              upcoming
                ? 'text-slate hover:text-navy'
                : 'text-amber hover:text-amber-dark'
            }`}
          >
            {upcoming ? 'Preview issue' : 'View issue'}
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </article>
  );
}

export default IssueCard;
